export const formatTime = (time) => {
  let type = "";
  let newArray = time.split("");
  let hour = newArray[0].concat(newArray[1]);
  let minute = newArray[3].concat(newArray[4]);
  if (hour === "00") {
    hour = 12;
    type = "AM";
  }
  if (hour === "12") {
    hour = 12;
    type = "PM";
  }
  if (hour > 12) {
    hour = hour - 12;
    type = "PM";
  }
  if (hour < 12) {
    type = "AM";
  }
  return (
    <div>
      {hour}:{minute}&nbsp;{type}
    </div>
  );
};
